import { Routes } from '@angular/router';
import {PaymentMainComponent} from "./pages/payment-main/payment-main.component";
import {LookPaymentComponent} from "./pages/look-payment/look-payment.component";
import {ConfirmPageComponent} from "./pages/confirm-page/confirm-page.component";
import {CheckUnsubscriptionComponent} from "./pages/check-unsubscription/check-unsubscription.component";
import {UnsubscriptionComponent} from "./pages/unsubscription/unsubscription.component";

export const routes: Routes = [

  {
    path: '',
    children: [
      {
        path: '',
        component: PaymentMainComponent,
      },
      {
        path: 'confirm',
        component: ConfirmPageComponent,
      },
      {
        path: 'success',
        component: UnsubscriptionComponent,
      },
      {
        path: 'search',
        children: [
          {
            path: '',
            component: LookPaymentComponent,
          },
          {
            path: ':code',
            component: CheckUnsubscriptionComponent,
          },
        ]
      },
    ]
  },

  {
    path: '**',
    redirectTo: '/',
    pathMatch: 'full',
  },
];
